<template>
    <section class="monitoring-page">
        <Container width="landing" class="monitoring-page__container">
            <PageHead class="monitoring-page__head">
                <template #title>
                    {{ pageHeader.title }}
                </template>
                <template #top_control>
                    <UiButton class="monitoring-page__head-button _mobile" color="primary" @click="handleAddProject">
                        <WBIcon name="plus" />
                    </UiButton>
                </template>
                <template #description>
                    <p>{{ pageHeader.description }}</p>
                </template>
                <template #components>
                    <MonitoringIncreaseLimit />
                </template>
                <template #controls>
                    <UIHeading level="4" class="monitoring-page__head-controls__title">
                        Мои проекты
                    </UIHeading>
                    <MonitoringSearch />
                    <UiButton class="monitoring-page__head-button _desktop" color="primary" @click="handleAddProject">
                        Создать проект
                    </UiButton>
                </template>
            </PageHead>
            <ProjectGroupList class="monitoring-page__list" :project-groups="projectGroups" :is-loading="isMonitoringGroupsLoading" />
            <VPagination v-if="false" class="monitoring-page__pagination" :pagination="pagination" />
        </Container>
    </section>
</template>

<script setup>
    import { useGetMonitoringProjectGroups } from '~/src/features/monitoring/api/index'
    import ProjectGroupList from '~/src/features/monitoring/components/ProjectGroupList/ProjectGroupList.vue'
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import PageHead from '~/src/shared/components/pages/common/PageHead.vue'
    import MonitoringIncreaseLimit from '~/src/shared/components/pages/monitoring/MonitoringIncreaseLimit.vue'
    import MonitoringSearch from '~/src/shared/components/pages/monitoring/MonitoringSearch.vue'
    import { useModalStore } from '~/src/shared/pinia/modal/useModalStore'

    const AddProjectGroupModal = defineAsyncComponent(() => import('~/src/features/monitoring/components/AddProjectGroupModal/AddProjectGroupModal.vue'))

    const pageHeader = {
        title: 'Мониторинг позиций',
        description: 'Инструмент “управление ценой” сравнивает цены на товары и  автоматически корректируйте стоимость ваших товаров относительно конкурентов.'
    }
    const pagination = [
        {
            number: 1
        },
        {
            number: 2
        },
        {
            number: 3
        },
        {
            number: 4
        }
    ]

    const { data: projectGroups, suspense, isLoading: isMonitoringGroupsLoading } = useGetMonitoringProjectGroups()

    onServerPrefetch(async () => {
        await suspense()
    })

    const handleAddProject = () => {
        useModalStore().open(AddProjectGroupModal)
    }
</script>

<style lang="scss" scoped>
     .monitoring-page {
        padding-top: 28px;
        padding-bottom: 60px;

        @include respond-to(mobile) {
            padding-top: 8px;
            padding-bottom: 12px;
        }

        &__head {
            position: relative;

            &-controls__title {
                display: none;

                @include mulish20b;

                @include respond-to(mobile) {
                    display: block;
                    width: 100%;
                    margin-bottom: 16px;
                }
            }

            &-button {
                &._mobile {
                    display: none;
                    padding: 12px;
                    border-radius: 50%;

                    :deep(.icon) {
                        width: 14px;
                        height: 14px;
                        color: var(--white);
                    }

                    @include respond-to(mobile) {
                        display: block;
                    }
                }

                &._desktop {
                    @include respond-to(mobile) {
                        display: none;
                    }
                }
            }
        }

        &__pagination {
            margin-top: 20px;
            margin-left: auto;

            @include respond-to(mobile) {
                margin-top: 24px;
            }
        }
    }
</style>
